import { Http } from "../axios/interceptors";

export const qrBot = async (guid) =>
  Http("GET", `/QRBot/Get?guidCompany=${guid}`);
